import { Controller } from "stimulus";

export default class extends Controller {
  connect = () => {
    // Check if the cookie has already been accepted, if so, don't show the bar.
    this.cookieIsAccepted() ? this.removeToast() : null;
  };

  // This method is fired when a user accepts the cookie.
  accept = () => {
    this.writeAcceptCookie();
    this.removeToast();
  };

  // Check the cookie has been accepted in the past 30 days.
  cookieIsAccepted = () =>
    document.cookie.split(";").filter(c => c.trim().startsWith("cookieAccepted="))
      .length != 0;


  // Creates the cookie and sets it to expire in 30 days.
  writeAcceptCookie = () => {
    document.cookie = `cookieAccepted=true; ${this.cookieExpiryString()}`;
  };

  // Clears the cookie.
  clearAcceptCookie = () =>
    (document.cookie =
      "cookieAccepted=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/");

  // Remove the DOM element representing the toast bar.
  removeToast = () => this.element.parentNode.removeChild(this.element);

  // "30 days from now" to cookie string.
  cookieExpiryString = () => {
    const exdays = 30;
    let d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);

    return `expires=${d.toUTCString()}; path=/`;
  };
}